export const DisplayErrorCodeEnum = {
  CARD_HEX_NOT_VALID: "CARD_HEX_NOT_VALID",
  PROFILE_NOT_SELECTED: "PROFILE_NOT_SELECTED",
  SESSION_NOT_ACTIVE: "SESSION_NOT_ACTIVE",
  SCANNER_INVALID_CODE: "SCANNER_INVALID_CODE",
  POI_USER_CANCEL: "POI_USER_CANCEL",
  POI_TIMEOUT: "POI_TIMEOUT",
  CARD_ORDER_NOT_SENT: "CARD_ORDER_NOT_SENT",
  CARD_ORDER_TIMED_OUT: "CARD_ORDER_TIMED_OUT"
} as const;

export type DisplayErrorCode =
  (typeof DisplayErrorCodeEnum)[keyof typeof DisplayErrorCodeEnum];

export class DisplayError extends Error {
  code: DisplayErrorCode;

  constructor(code: DisplayErrorCode) {
    super(code);
    this.code = code;
    this.name = "DisplayError";
  }
}

export function isDisplayError(error: unknown): error is DisplayError {
  return error instanceof DisplayError;
}
